// @file Vuex plugin that log mutations in Chrome console.
/* eslint-disable no-console */
import cloneDeep from 'lodash.clonedeep'
import { Store } from 'vuex'

export default (store: Store<any>): void => {
  store.subscribe((mutation, state): void => {
    const d = new Date()
    const pad = (num: number, size: number): string => {
      let s: string
      s = num + ''
      while (s.length < size) {
        s = '0' + s
      }
      return s
    }

    const formattedDate =
      pad(d.getHours(), 2) +
      ':' +
      pad(d.getMinutes(), 2) +
      ':' +
      pad(d.getSeconds(), 2) +
      '.' +
      pad(d.getMilliseconds(), 3)
    console.groupCollapsed('%cmutate @', 'color: #18b11e; font-weight: bold', formattedDate, mutation.type)
    console.log('%c prev state', 'color: blue; font-weight: bold', cloneDeep(store.state))
    console.log('%c action', 'color: black; font-weight: bold', mutation)
    console.log('%c current state', 'color: green; font-weight: bold', cloneDeep(state))
    console.groupCollapsed('%c trace', 'color: red; font-weight: bold')
    console.log(new Error('Trace using Error.stack').stack)
    console.groupCollapsed('Trace using console.trace')
    console.trace()
    console.groupEnd()
    console.groupEnd()
    console.groupEnd()
  })
}
